<template>
<b-row>
  <b-col v-if="isCheckbox" :cols="labelCols ? labelCols : 2" class="checkbox-label">
    <label :for="`checkbox-${inputId}`">
      {{ fileTypeName }}
    </label>
  </b-col>
  <b-col v-if="isCheckbox"  md="auto">
    <div style="padding-top: 0.7rem;">
    <b-form-checkbox
      :disabled="disabled"
      :name="`checkbox-${inputId}`"
      :id="`checkbox-${inputId}`"
      :checked="value"
      v-on:input="$emit('input', $event)"
      :value="true"
      :unchecked-value="false"
      style="margin-right: 0px;"
    >
    </b-form-checkbox>
    </div>
  </b-col>
  <b-col class="shinked-label">
    <span v-b-tooltip.hover.topleft :title="getFileName">
      {{shrinkedFileName}}
    </span>
  </b-col>
  <b-col class="upload-button" md="auto">    
    <file-upload
          v-b-tooltip.hover.topleft :title="$t('Загрузить')"
          v-if="!isNotVisible"
          :class="uploadInProgress ? 'btn btn-secondary btn-sm' : 'btn btn-primary btn-sm'"
          :post-action="postAction"
          :multiple="false"
          :size="size"
          :headers="headers"
          :data="data"
          :add-index="addIndex"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          :input-id="inputId"
          :ref="inputId">
          <span key="spinner" v-if="uploadInProgress">
            <i class='fas fa-spinner fa-pulse'></i>
          </span>
          <span key="uploader" v-else>
            <i class='fa fa-upload'></i>
          </span>
        </file-upload>        
        <a v-if="fileId && !uploadInProgress" class="btn btn-secondary btn-sm ml-2" :href="downloadUrl"  v-b-tooltip.hover.topleft :title="$t('Скачать')">          
          <i class="fa fa-download"></i>
        </a>
  </b-col>
</b-row>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import FileUpload from 'vue-upload-component';
import Constants from '../constants';
import { EventBus } from '@/event-bus';
import { mapGetters } from 'vuex';
import { from } from 'rxjs';

export default {
  props: {
    id: null,
    fileInfo: null,
    inputId: null,
    fileTypeName: null,
    entityType: null,
    isNotVisible: null,
    isCheckbox: null,
    labelCols: null,
    value: null,
    disabled: null
  },
  components: {
    FileUpload,
  },
  data() {
    return {
      files: [],
      minSize: 1,
      size: 1024 * 1024 * 10,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      postAction: Constants.baseUrl + '/file',
      data: {
        id: this.id,      
        entityType: this.entityType,
        fileTypeName: this.fileTypeName
      },
      headers: {'Authorization': `Bearer ${localStorage['rdkm_auth_token']}`},
      uploadAuto: true,
      isOption: false,
      fileTypes: [],
      fileType: null,
      newFile: '',
      newFileTypeVisible: false,
      newFileTypeName: '',
      uploadedFileId: null
    };
  },
  methods: {        
    removeFile(file) {    
      this.$refs[this.inputId].remove(file);
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {      
      if (newFile && oldFile) {        

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          this.uploadedFileId = newFile.response;
          this.$emit('input', true);
          this.$emit('uploaded', newFile);
        }

        if (
          newFile.error &&
          !oldFile.error 
        ) {
          let errorMessage = newFile.error === 'denied' ? this.$t('Пользовательская сессия закончилась. Обновите страницу.') : '';
          errorMessage = newFile.error === 'size' ? this.$t('Размер файла должен быть больше 1 байта и меньше 10 Мб') : errorMessage;
          errorMessage = newFile.error === 'network' ? this.$t('Отсутствует соединение с сервером') : errorMessage;
          errorMessage = newFile.response && newFile.response.message ? newFile.response.message : errorMessage;

          EventBus.$emit('error', { msg: errorMessage });
          this.removeFile(newFile);
        }
      }

      if (newFile && !oldFile) {
        if (this.uploadAuto && !this.$refs[this.inputId].active) {
          if(this.id)
          {
            this.setActive(this.id);
          }
          else
          {
            this.$emit('startUpload');
          }          
        }
      }
    },
    setActive(id) {
      this.$refs[this.inputId].active = true;
      this.file.data.id = id;
    },
    clearFiles() {
      this.files.splice(0);
      this.uploadedFileId = null;
    },
    showError(message) {
      this.$swal({
        icon: 'error',
        title: 'Ошибка',
        text: message,
        dangerMode: true,
      });
    }    
  },
  computed: {
    uploadInProgress() {
      return this.file && this.file.active;
    },

    file() {
      return this.files.length === 1 ? this.files[0] : null;
    },

    getFileName() {
      let result = '';
      if (!this.file) {
        if (!this.fileInfo || !this.fileInfo.name) {
          return result;
        } else {
          result = this.fileInfo.name;
        }
      }
      else
      {
        result = this.file.name;
      }
          
        return result;
    },

    shrinkedFileName() {
      if(this.getFileName)
      {
        return (this.getFileName.length > 14) ? this.getFileName.substr(0, 14 - 1) + '...' : this.getFileName;
      }
    },

    fileId() {
      return this.uploadedFileId || (this.fileInfo != null ? this.fileInfo.id : null);
    },

    downloadUrl() {
      return Constants.baseUrl + "/file/" + this.fileId;
    }
  },
  watch: {
    id: function(val) {
      this.data.id = val;
    },
    entityType: function(val) {
      this.data.entityType = val;
    },
    fileTypeName: function(val) {
      this.data.fileTypeName = val;
    }
  }
};
</script>

<style scoped>
.file-name {

  white-space: nowrap;
  overflow: hidden;
}

.no-paddings {
  padding: 0;
}
</style>
